import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import './ButtonCard.scss';

const useStyles = makeStyles((theme) => ({
  primary: {
    '&::before': {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

export default function ButtonCardWithFunction(props) {

  const color = props.color || 'primary';
  const onClick = props.onClick || function () { };

  const borderColor = color === 'primary' ? useStyles().primary : '';

  return (

    <div className={`button-card button-card-fn shadow-sm d-flex justify-content-center align-items-center`}>
      <Button type="submit" onClick={onClick} variant="contained" color={color} className={`${borderColor} ${props.className}`}>{props.icon}<span className="name text-center">{props.name}</span></Button>
    </div >
  )
}

ButtonCardWithFunction.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  icon: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  shape: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Helpers/Buttons/ButtonCardWithFunction.js